const submitWhitepaper2024Form = require("../../run/whitepaper2024/submitWhitepaper2024Form");

/**
 * @param form {HTMLFormElement}
 * @return {void}
 */
module.exports = function whenWhitepaper2024FormSubmits(form) {
    submitWhitepaper2024Form(form);
}
